import { TFunction } from 'i18next';

import { Locale } from 'modules/domains/template';
import { LocaleOption } from 'modules/templateEditor/common/types';
import { Nullish } from 'utils/tsHelpers';
import { LocaleLabel } from '../../../../templateEditor/common/LocaleLabel/LocaleLabel';

export const formatDisplayValue = (
  tags: string,
  maxTagsLength: number,
  selectedLocaleTags: string[],
  activeTemplateLocales: Locale[],
) => {
  const cappedLocaleTagsString = tags.slice(0, maxTagsLength);
  const lastValPos = cappedLocaleTagsString.lastIndexOf(',');
  const finalLocaleTagsString = cappedLocaleTagsString.slice(0, lastValPos);
  const finalLocaleTags = finalLocaleTagsString.split(', ');

  const filteredTemplateLocales = activeTemplateLocales
    .filter((locale) => {
      return selectedLocaleTags.some((tag) => tag === locale.tag);
    })
    .filter((locale) => !finalLocaleTags.some((tag) => tag === locale.tag));

  return {
    text: finalLocaleTagsString,
    filteredLocales: filteredTemplateLocales,
  };
};

export const getLocaleOptions = (
  projectLocales: Locale[],
  defaultLocale: Nullish<Locale>,
  translation: TFunction,
) =>
  projectLocales.map((projectLocale) => {
    return {
      categoryId: translation('label.active'),
      id: projectLocale.tag,
      label: <LocaleLabel locale={projectLocale} />,
      value: projectLocale.tag,
      Suffix: defaultLocale?.tag === projectLocale.tag && translation('label.defaultLocale'),
      isDisabled: defaultLocale?.tag === projectLocale.tag,
      data: projectLocale,
    } as LocaleOption;
  });
